import { IAddressFieldConfig } from '../details/addresses/address/address.interface';

export default class FieldHelper {
    public static groupField<T extends IAddressFieldConfig>(fieldConfig: T[]): T[][] {
        let length = fieldConfig.length;
        let idx = 0;
        const result = [];
        while (length > 0) {
            const current = fieldConfig[idx];
            const column = current.span;
            if (column === 1) {
                const next = fieldConfig[idx + 1];
                if (next && next.span === 1) {
                    result.push([current, next]);
                    idx += 2;
                    length -= 2;
                    continue;
                } else {
                    result.push([current]);
                    idx += 1;
                    length -= 1;
                    continue;
                }
            }

            if (column === 2) {
                result.push([current]);
                idx += 1;
                length -= 1;
                continue;
            }
        }

        return result;
    }
}
